import { render, staticRenderFns } from "./seriesCategoryPage.vue?vue&type=template&id=2ed945eb&"
import script from "./seriesCategoryPage.vue?vue&type=script&lang=js&"
export * from "./seriesCategoryPage.vue?vue&type=script&lang=js&"
import style0 from "./seriesCategoryPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "seriesCategoryPage.vue"
export default component.exports